import { FaInfoCircle } from 'react-icons/fa';
import { PopoverBody, UncontrolledPopover} from 'reactstrap';

const InfoTooltip = ({ text, container='body' }) => {
  const tooltipId = `info-tooltip-${Math.random().toString(36).substr(2, 5)}`;
  return (
    <>
      <FaInfoCircle id={tooltipId} className="ml-1 "/>
      <UncontrolledPopover placement="right" target={tooltipId} trigger={'hover'} container={container}>
        <PopoverBody>
          {text}
        </PopoverBody>
      </UncontrolledPopover>
    </>
  )
}

export default InfoTooltip;